import { useDevice } from 'device'
import links from 'links'
import { usePathname } from 'router'

import type { TextStyle } from 'components/dataDisplay'

import bouqsLogo from '../images/bouqsLogo.png'

import messages from './messages'


type CustomHeroTextStyles = {
  title: TextStyle
  text: TextStyle
  note: TextStyle
}

type CustomHeroTimer = {
  withLabel: boolean
}

const getCustomHeroTextsByPathname = (pathname: string) => {
  if (pathname === links.nift) {
    return messages.nift
  }

  if (pathname === links.bouqs) {
    return messages.bouqs
  }
}

const getCustomHeroTextStylesByPathname = (pathname: string, isMobile: boolean): CustomHeroTextStyles => {
  if (pathname === links.nift || pathname === links.bouqs) {
    return {
      title: isMobile ? 'h4' : 'h2',
      text: isMobile ? 'p2' : 'sh4',
      note: isMobile ? 'p2' : 'sh6',
    }
  }
}

const getCustomHeroTimerByPathname = (pathname: string): CustomHeroTimer => {
  if (pathname === links.bouqs) {
    return {
      withLabel: false,
    }
  }
}

const getCustomHeroLogoImageByPathname = (pathname: string): string => {
  if (pathname === links.bouqs) {
    return bouqsLogo
  }
}

const useLandingCustomHeroTexts = () => {
  const pathname = usePathname()
  const { isMobile } = useDevice()

  const customHeroTexts = getCustomHeroTextsByPathname(pathname)
  const customHeroTextStyles = getCustomHeroTextStylesByPathname(pathname, isMobile)
  const customHeroTimer = getCustomHeroTimerByPathname(pathname)
  const customHeroLogoImage = getCustomHeroLogoImageByPathname(pathname)

  return {
    customHeroTexts,
    customHeroTextStyles,
    customHeroTimer,
    customHeroLogoImage,
  }
}


export default useLandingCustomHeroTexts
